export default "__VITE_ASSET__BAQxGxN5__"